import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function FourPointStar({
  outline,
  ...props
}: IconProps & { outline?: boolean }) {
  if (outline) {
    return null;
  }

  return <FourPointStar.Filled {...props} />;
}

FourPointStar.Filled = function Filled({ name, outline, ...props }: IconProps) {
  const style = outline
    ? { fill: "none", stroke: "currentColor", strokeWidth: "1.5" }
    : { fill: "currentColor" };

  const Icon = createWebIcon({
    ...props,
    name: `${name}${outline ? "Outline" : "Filled"}`,
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        {...style}
        d="M12.16,23.04h-0.39c0-3.02-1.13-5.67-3.39-7.93C6.07,12.91,3.42,11.78,0.39,11.78v-0.39 c3.03,0,5.67-1.13,7.93-3.39C10.58,5.73,11.71,3.08,11.71,0.05h0.39c0,3.02,1.13,5.67,3.39,7.93c2.26,2.26,4.91,3.39,7.93,3.39v0.39 c-3.02,0-5.67,1.13-7.93,3.39C13.29,17.37,12.16,20.02,12.16,23.04L12.16,23.04z"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

FourPointStar.Outline = function Outline(props: IconProps) {
  return <FourPointStar.Filled {...props} outline />;
};
